module.exports = __webpack_public_path__ + "static/media/Edit.52ae2f0c.svg";